"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/store.ts
var _store = require('@ariakit/react-core/utils/store');



exports.useStoreState = _store.useStoreState;
